export enum GeneralsMenuTabsEnum {
    BOMBORA_INTENT = 'BOMBORAINTENT',
    PREDICTIVEINTENT = 'PREDICTIVEINTENT',
}
